import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import fp from 'lodash/fp';
import { media, color } from '@deerplusofficial/pos-helper';
import { ButtonBase, Icon, Button } from '@deerplusofficial/pos-components';
import withDatepicker from '../../assist/withDatepicker';
import { withPrintSummary } from '../../model/Mutations';
import { Toolbar } from '../../components';

const Container = styled(Toolbar)`
  ${media(
    'tablet',
    css`
      position: static;
      transform: none;
    `
  )};
`;

const Inner = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 10px;
  ${media(
    'tablet',
    css`
      padding: 0;
    `
  )};
`;

const Info = styled.div`
  margin-top: auto;
  ${media(
    'tablet',
    css`
      display: flex;
      align-items: center;
      padding: 20px;
    `
  )};
`;

const Title = styled.div`
  display: none;
  font-size: 19px;
  ${media(
    'tablet',
    css`
      display: block;
    `
  )};
`;

const PrintButton = styled(Button)`
  width: 100%;
  ${media(
    'tablet',
    css`
      margin-left: auto;
      max-width: 250px;
    `
  )};
`;

const Filters = styled.div`
  order: -1;
  ${media(
    'tablet',
    css`
      display: flex;
      order: 0;
      border: solid 1px ${color.border};
      border-width: 1px 0;
    `
  )};
`;

const FilterGroup = styled.div`
  margin-bottom: 10px;
  border-bottom: solid 1px ${color.border};
  ${media(
    'tablet',
    css`
      display: flex;
      margin-bottom: 0;
      padding: 10px 20px;
      width: 50%;
      justify-content: space-between;
      align-items: center;
      border-bottom: 0;
      &:first-child {
        border-right: solid 1px ${color.border};
      }
    `
  )};
`;

const FilterLabel = styled.label``;

const FilterInputWrapper = styled.div`
  display: flex;
  justify-content: space-space-between;
  align-items: center;
  padding: 10px 0;
  ${media(
    'tablet',
    css`
      flex-grow: 1;
      padding: 0;
    `
  )};
`;

const OrderNumberForm = FilterInputWrapper.withComponent('form');

const FilterInput = styled.input.attrs({ type: 'text' })`
  margin: 0;
  padding: 0 10px 0 0;
  border: none;
  box-shadow: none;
  outline: 0;
  flex-grow: 1;
  width: 100%;
  color: ${color.text.secondary};
  ${media(
    'tablet',
    css`
      padding: 10px;
    `
  )};
`;

const FilterIcon = styled(Icon)`
  font-size: 18px;
  color: ${color.text.title};
`;

const Datepicker = styled(withDatepicker()(FilterInput))`
  flex-grow: 1;
`;

const Dash = styled.div`
  margin: 0 1em;
`;

class Header extends Component {
  static propTypes = {
    active: PropTypes.bool,
    startDate: PropTypes.shape(),
    endDate: PropTypes.shape(),
    orderNumber: PropTypes.string,
    onToggleClick: PropTypes.func,
    onQueryOrders: PropTypes.func,
    onStartDateChange: PropTypes.func,
    onEndDateChange: PropTypes.func,
    onOrderNumberChange: PropTypes.func,
  };

  static defaultProps = {
    active: false,
    startDate: {},
    endDate: {},
    orderNumber: '',
    onToggleClick: fp.identity,
    onQueryOrders: fp.identity,
    onStartDateChange: fp.identity,
    onEndDateChange: fp.identity,
    onOrderNumberChange: fp.identity,
  };

  onPrintButtonClick = async e => {
    const { startDate, endDate, onSummaryPrint } = this.props;

    e.preventDefault();

    onSummaryPrint({ startDate, endDate });
  };

  onSubmit = e => {
    e.preventDefault();

    this.props.onQueryOrders();
  };

  render() {
    const {
      active,
      onToggleClick,
      startDate,
      endDate,
      orderNumber,
      onStartDateChange,
      onEndDateChange,
      onOrderNumberChange,
      onQueryOrders,
    } = this.props;

    return (
      <Container label="店頭訂單" active={active} onToggleClick={onToggleClick}>
        <Inner>
          <Info>
            <Title>店頭訂單</Title>
            <PrintButton primary icon="print" onClick={this.onPrintButtonClick}>
              列印清帳條
            </PrintButton>
          </Info>
          <Filters>
            <FilterGroup>
              <FilterLabel>銷售日期</FilterLabel>
              <FilterInputWrapper>
                <Datepicker
                  id="start-date"
                  moment={startDate}
                  onMomentChange={onStartDateChange}
                  onBlur={onQueryOrders}
                />
                <Dash>-</Dash>
                <Datepicker
                  id="end-date"
                  moment={endDate}
                  startDate={startDate}
                  onMomentChange={onEndDateChange}
                  onBlur={onQueryOrders}
                />
                <ButtonBase
                  onClick={this.onSubmit}
                  disabled={fp.size(orderNumber)}
                >
                  <FilterIcon icon="calendar-alt" />
                </ButtonBase>
              </FilterInputWrapper>
            </FilterGroup>
            <FilterGroup>
              <FilterLabel>輸入訂單編號</FilterLabel>
              <OrderNumberForm onSubmit={this.onSubmit}>
                <FilterInput
                  value={orderNumber}
                  onChange={onOrderNumberChange}
                />
                <ButtonBase type="submit">
                  <FilterIcon icon="search" />
                </ButtonBase>
              </OrderNumberForm>
            </FilterGroup>
          </Filters>
        </Inner>
      </Container>
    );
  }
}

export default withPrintSummary()(Header);



// WEBPACK FOOTER //
// ./src/pages/Orders/Header.js